<template>
    <transition name="fade" v-if="is_open">
        <div class="cookies-popup">
            <div class="box">
                <div class="text" v-html="$store.state.cookies.text"></div>
                <div class="close-btn"><Button @click.native="close" :size="'small'">OK</Button></div>
                <div class="link-btn" v-if="$store.state.cookies.button_text && $store.state.cookies.button_link"><Button :size="'small'" @click.native="close" :link_url="$store.state.cookies.button_link">{{$store.state.cookies.button_text}}</Button></div>
            </div>
        </div>
    </transition>
</template>

<script>
import Button from '@/components/ui/Button.vue';

export default {
    name: 'cookies',
    components: {
        Button,
    },
    data() {
        return {
            is_open: true,
        }
    },
    methods: {
        close() {
            this.$emit('close');
            window.localStorage.setItem('hide_cookies', 1);
            this.is_open = false;
        },
    },

}
</script>

<style lang="scss">

    .fade-enter-active, .fade-leave-active {
        opacity: 1;
        transition: opacity .3s ease-in-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .cookies-popup {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 999;
        padding: var(--padding);
        background: var(--gray);
        box-sizing: border-box;
        width: 100%;
        color: black;

        .box {
            display: flex;
            flex-wrap: wrap;
        }

        .ui-button {
            cursor: pointer;
            margin-left: var(--padding);
            color: black;
            border-color: black;

            &:hover {
                background: black;
                color: white;
            }
        }
    }

</style>
